import { DASHBOARD } from '../utils/APIUtil';
import AuthService from './auth/AuthService';

const Auth = new AuthService();
export default class DashboardService {
  constructor() {
    this.fetch = this.fetch.bind(this);
  }

  getDashboard() {
    return this.fetch(DASHBOARD, {
      method: 'GET',
    }).then(res => {
      if (res.result === 'NOK') {
        return Promise.reject(res.error);
      }
      return Promise.resolve(res);
    });
  }

  fetch(url, options) {
    // performs api calls sending the required authentication headers
    const headers = {
      'Accept': 'application/json',
    };
    headers['Authorization'] = 'Bearer ' + Auth.getToken();
    return fetch(url, {
      headers,
      ...options,
    })
      .then(this._checkStatus)
      .then(response => response.json());
  }

  _checkStatus(response) {
    // raises an error in case response status is not a success
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  }
}
